export const acceptedInformationCollaboratorInitialState = {
	collaborators: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
